module.exports = __webpack_public_path__ + "media/favicon/mstile-144x144-40e13581c1f6327b381ffceace878353.png";